import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickBuild } from '../../quick-build.service';
import { ChatService as ChatProtoService, ChatRequest } from 'ldt-chat-proto-api';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/notification-service/notification.service';
import { QuickBuildSchema } from '../../quick-build-validators';

export interface ChatToQueryResult {
  id: string;
  prompt: string;
  quickBuild: QuickBuild;
}

@Component({
  selector: 'app-people-chat-to-filters',
  templateUrl: './chat-to-filters.component.html',
  styleUrls: ['./chat-to-filters.component.scss'],
  standalone: false,
})
export class ChatToFiltersComponent {
  @Input() orgId: string;
  @Output() quickBuild = new EventEmitter<ChatToQueryResult>();

  prompt: string;
  prompting: boolean = false;
  assessOption: boolean = false; // If there was ever a prompt
  lastResponse: any; // TODO ChatDefaultResponse;

  constructor(
    private chatProtoService: ChatProtoService,
    private notify: NotificationService
  ) {}

  chat() {
    if (!this.prompt || this.prompt.trim().length === 0) return;

    this.prompting = true;
    this.assessOption = false;

    const req: ChatRequest = {
      prompt: this.prompt,
    };

    // Track Intercom event for chat-to-filters submission
    if ((window as any).Intercom) {
      (window as any).Intercom('trackEvent', 'chat_to_filters_submitted', {});
    }

    this.chatProtoService.chat(this.orgId, req).subscribe({
      next: (qb) => {
        if (!qb.response) {
          this.notify.error('No response from chat API');
          return;
        }

        try {
          const parsedParams = JSON.parse(qb.response);
          const result = QuickBuildSchema.safeParse(parsedParams);

          if (!result.success) {
            console.error('Invalid quickbuild schema:', result.error);
            throw new Error('Invalid quickbuild schema');
          }

          this.quickBuild.emit({
            id: qb.id || 'UNKNOWN',
            prompt: req.prompt || '',
            quickBuild: parsedParams as QuickBuild,
          });
          this.prompting = false;
          this.assessOption = true;

          this.lastResponse = qb;
        } catch (err: unknown) {
          this.prompting = false;
          console.error('Error parsing quickbuild:', err);
          this.notify.error('Invalid response from chat. Try changing your prompt.');
        }
      },
      error: (err) => {
        this.prompting = false;
        console.error('Error chatting with LDT:', err);
        if ('message' in err) {
          if (err.message.includes('Invalid quickbuild schema')) {
            this.notify.error(
              'Invalid response from chat. Try changing your prompt. This error was already reported, no need to assess.'
            );
            return;
          }
          this.notify.error('Error connecting with chat. Try again.');
          return;
        }
        this.notify.error('Error connecting with chat.');
      },
    });
  }
}
